// components
import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  user: getIcon('ic_user'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
};

const sidebarConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'general v3.0.0',
    items: [
      { title: 'One', path: '/superadmin/one', icon: ICONS.dashboard },
      { title: 'Two', path: '/superadmin/two', icon: ICONS.ecommerce },
      { title: 'Three', path: '/superadmin/three', icon: ICONS.analytics },
    ],
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: 'management',
    items: [
      {
        title: 'user',
        path: '/superadmin/user',
        icon: ICONS.user,
        children: [
          { title: 'Four', path: '/superadmin/user/four' },
          { title: 'Five', path: '/superadmin/user/five' },
          { title: 'Six', path: '/superadmin/user/six' },
        ],
      },
    ],
  },
];

export default sidebarConfig;
